export enum BookkeepersTableStaticActionType {
  Delete = 'delete',
}
